import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

import FamilyPlazaTopSection from '../../../../components/family-plaza/FamilyPlazaTopSection';
import FamilyPlazaSubHeading from '../../../../components/family-plaza/FamilyPlazaSubHeading';
import PaymentInquiry from '../../../../services/FamilyPlaza/PaymentInquiry';

const ManagementFeeInquiryResultsPC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const [feeData, setFeeData] = useState(null);
  const [birthDate, setBirthDate] = useState('');
  const [loading, setLoading] = useState(true);


  //   // // Load management fee data from API using goinId from navigation state
  useEffect(() => {
    const loadFeeData = async () => {
      try {
        let paramData = {};
        const goinId = location.state?.goinId;
        const birthday = location.state?.birthday;

        if (goinId) {
           paramData = {
            goinId: goinId,
            birthday: birthday,
            mode: 1,
          }
        } else if(location.state?.enshrineName && location.state?.deceasedName) {
           paramData = {
            goinId: location.state?.goinIdMode2,
            birthday: location.state?.birthdayMode2,
            mode: 2,
          }
        }
          const response = await PaymentInquiry.getFeePaymentInfo(paramData);
          if (response) {

            const mappedData = {
              deceasedName: response.deceasedInfo.deceasedName, // "이주홍"
              contractorName: response.deceasedInfo.customerName, // ""
              enshrineUnit: response.deceasedInfo.enshrineName, // "다1단3열322"
              firstEnshrineDate: response.deceasedInfo.enshrineDay, // "2022-07-19"
              feeStatus: response.paidFees.length > 0 ? "Paid" : "Unpaid", // Based on the presence of paid fees
              lastPaymentDate: response.paidFees.length > 0 ? response.paidFees[0].receiptDay : "", // "2022-07-19"
              nextPaymentDate: response.paidFees.length > 0 ? response.paidFees[0].endDay : "", // "2027-07-18"
              amount: response.paidFees.length > 0 ? response.paidFees[0].receiptPrice : 0, // 600000
              paymentStatus: response.paidFees.length > 0 ? (response.paidFees[0].paymentFlag === "1" ? "Paid" : "Pending") : "Unpaid", // "Paid"

              // Store the full paidFees array for displaying multiple payment records
              paidFees: response.paidFees || [],

              // Store the full unpaidFees array for displaying multiple unpaid payment records
              unpaidFees: response.unpaidFees || [],

              // Additional fields for detailed view
              managementStartDate: response.paidFees.length > 0 ? response.paidFees[0].startDay : "", // "2022-07-19"
              managementEndDate: response.paidFees.length > 0 ? response.paidFees[0].endDay : "", // "2027-07-18"
              unpaidPaymentDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].receiptDay : "", // First unpaid fee date
              unpaidPaymentAmount: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].receiptPrice : 0, // First unpaid fee amount
              unpaidStartDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].startDay : "", // First unpaid fee start date
              unpaidEndDate: response.unpaidFees && response.unpaidFees.length > 0 ? response.unpaidFees[0].endDay : "", // First unpaid fee end date


            };


            setFeeData(mappedData);
          }
        
      } catch (error) {
        console.error('Error loading fee data:', error);

      } finally {
        setLoading(false);
      }
    };

    loadFeeData();
  }, [location.state?.goinId]);

  
  const handleBirthDateInquiry = async () => {
    if (!birthDate.trim()) {
      alert('계약자 생년월일을 입력해주세요.');
      return;
    }

    // Validate birth date format (YYYYMMDD)
    const birthDateRegex = /^\d{8}$/;
    if (!birthDateRegex.test(birthDate)) {
      alert('생년월일은 8자리 숫자로 입력해주세요. (예: 19800101)');
      return;
    }

    try {
      const isMode2Context = Boolean(location.state?.enshrineName && location.state?.deceasedName);
      const nameCandidates = isMode2Context
        ? [
            feeData?.deceasedName,
            location.state?.deceasedName,
            location.state?.customerNameMode2,
            location.state?.customerName,
            feeData?.contractorName,
          ]
        : [
            feeData?.deceasedName,
            location.state?.deceasedName,
            location.state?.customerName,
            feeData?.contractorName,
            location.state?.customerNameMode2,
          ];
      const customerName = nameCandidates.find((name) => typeof name === 'string' && name.trim())?.trim();

      if (!customerName) {
        alert('계약자 정보를 찾을 수 없습니다.');
        return;
      }

      const addressPhoneParamData = {
        mode: isMode2Context ? 2 : 1,
        name: customerName,
        dob: birthDate.trim()
      };

      // Call the getAddressAndPhone API
      const response = await PaymentInquiry.getAddressAndPhone(addressPhoneParamData);

      if (response) {
        // Update fee data with contractor details from API response
        setFeeData(prevData => ({
          ...prevData,
          address: response.address,
          phone: response.phoneCell
        }));

        alert('계약자 정보가 조회되었습니다.');
      } else {
        alert('계약자 정보를 찾을 수 없습니다.');
      }
    } catch (error) {
      console.error('Birth date inquiry error:', error);
      alert('계약자 정보 조회에 실패했습니다. 다시 시도해주세요.');
    }
  };




  // --- Birth date inquiry for both Mode1 & Mode2 ---
  // const handleBirthDateInquiryStarlightMode2 = async () => {
  //   if (!birthDate.trim()) {
  //     alert('계약자 생년월일을 입력해주세요.');
  //     return;
  //   }

  //   let dob = birthDate.trim();
  //   if (dob.length === 7) dob = '0' + dob;

  //   const birthDateRegex = /^\d{8}$/;
  //   if (!birthDateRegex.test(dob)) {
  //     alert('생년월일은 8자리 숫자로 입력해주세요. (예: 19800101)');
  //     return;
  //   }

  //   try {
  //     const name = feeData?.contractorName || location?.state?.customerName;
  //     if (!name) {
  //       alert('계약자 정보를 찾을 수 없습니다.');
  //       return;
  //     }

  //     let response;

 
  //       const apiUrl = `https://gangwha-api.dvconsulting.org/api/v1/fee/address?mode=2&name=${encodeURIComponent(
  //         name
  //       )}&dob=${encodeURIComponent(dob)}`;
  //       const res = await fetch(apiUrl);
  //       response = await res.json();
     

  //     // Show alert first
  //     alert('계약자 정보가 조회되었습니다.');

  //     // Then update feeData
  //     setFeeData(prev => ({
  //       ...prev,
  //       address: response.address,
  //       phone: response.phoneCell
  //     }));
  //   } catch (error) {
  //     console.error('Birth date inquiry error:', error);
  //     alert('계약자 정보 조회에 실패했습니다. 다시 시도해주세요.');
  //   }
  // };

  // const handleBirthDateInquiry = () => {
  //   if (location?.state?.enshrineName) {
  //     handleBirthDateInquiryStarlightMode2();
  //   } else {
  //     handleBirthDateInquiryMode1();
  //   }
  // };


  return (
    <div className="management-fee-inquiry-results-pc page-management-fee-inquiry-results-pc announcement-list-page cyber-info-page-pc">
      <FamilyPlazaTopSection />

      <main className="main-content">
        <FamilyPlazaSubHeading heading="관리비 납부 조회" />

        <div className="management-fee-inquiry-results-main-content">
          <div className="management-fee-inquiry-results-page-content">
            <div className="management-fee-inquiry-results-container">
              <div className="management-fee-inquiry-results-content-area">

                {/* --- Contractor Info Section --- */}
                <div className="management-fee-inquiry-results-contractor-section">
                  <h2 className="management-fee-inquiry-results-section-title">계약자 정보</h2>

                  {loading ? (
                    <div className="management-fee-inquiry-results-loading">로딩중...</div>
                  ) : feeData && (
                    <div className="management-fee-inquiry-results-contractor-info">
                      <div className="management-fee-inquiry-results-info-row">
                        <div className="management-fee-inquiry-results-info-label">고인명</div>
                        <div className="management-fee-inquiry-results-info-value">{feeData.deceasedName}</div>
                        <div className="management-fee-inquiry-results-info-label">계약자명</div>
                        <div className="management-fee-inquiry-results-info-value">{feeData.contractorName || location?.state?.customerName}</div>
                      </div>
                      <div className="management-fee-inquiry-results-info-row">
                        <div className="management-fee-inquiry-results-info-label">안치단</div>
                        <div className="management-fee-inquiry-results-info-value">{feeData.enshrineUnit}</div>
                        <div className="management-fee-inquiry-results-info-label">최초 안치일</div>
                        <div className="management-fee-inquiry-results-info-value">{feeData.firstEnshrineDate}</div>
                      </div>

                      {/* --- BirthDate Input --- */}
                      <div className="management-fee-inquiry-results-info-row">
                        <div className="management-fee-inquiry-results-info-label">계약자 생년월일</div>
                        <div className="management-fee-inquiry-results-info-value">
                          <input
                            type="text"
                            placeholder="예) 19800101"
                            className="management-fee-inquiry-results-birth-input"
                            value={birthDate}
                            onChange={(e) => setBirthDate(e.target.value)}
                          />
                          <button
                            className="management-fee-inquiry-results-inquire-btn"
                            onClick={handleBirthDateInquiry}
                          >
                            조회
                          </button>
                        </div>
                      </div>

                      <div className="management-fee-inquiry-results-info-row">
                        <div className="management-fee-inquiry-results-info-value">
                          <div className="management-fee-inquiry-results-instruction-text">
                            계약자 생년월일을 입력하시면 등록된 주소와 전화번호를 확인하실 수 있습니다.
                          </div>
                        </div>
                      </div>

                      {/* --- Address & Phone --- */}
                      <div className="management-fee-inquiry-results-info-row management-fee-inquiry-results-info-row-inner">
                        <div className="management-fee-inquiry-results-info-row-inner-inner">
                          <div className="management-fee-inquiry-results-info-label">주소</div>
                          <div className="management-fee-inquiry-results-info-value">{feeData.address}</div>
                        </div>
                        <div className="management-fee-inquiry-results-info-row-inner-inner">
                          <div className="management-fee-inquiry-results-info-label">전화번호</div>
                          <div className="management-fee-inquiry-results-info-value">{feeData.phone}</div>
                        </div>
                      </div>
                    </div>
                  )}

                  <div className="management-fee-inquiry-results-note">
                    <p>※ 계약자 주소 또는 전화번호가 변경되었을 경우, 관리사무실에 알려주시어 올바른 정보를 유지하시기 바랍니다. (관리사무실 전화번호: 1599-9442)</p>
                  </div>
                </div>

                {/* --- Paid Fees --- */}
                <div className="management-fee-inquiry-results-payment-section">
                  <div className="management-fee-inquiry-results-section-header">
                    <h2 className="management-fee-inquiry-results-section-title">최종 관리비 납부 내역</h2>
                    <div className="management-fee-inquiry-results-date-reference">{new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })} 기준</div>
                  </div>
                  <div className="management-fee-inquiry-results-payment-table">
                    <table>
                      <thead>
                        <tr>
                          <th>최종 납부일</th>
                          <th>최종 납부금액</th>
                          <th>관리 기간</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feeData?.paidFees && feeData.paidFees.length > 0 ? (
                          feeData.paidFees.map((payment, index) => {
                            const start = payment.startDay || (payment.startEndDay ? String(payment.startEndDay).split('~')[0]?.trim() : '');
                            const end = payment.endDay || (payment.startEndDay ? String(payment.startEndDay).split('~')[1]?.trim() : '');
                            return (
                              <tr key={index}>
                                <td>{payment.receiptDay || '-'}</td>
                                <td>{payment.receiptPrice || '-'}</td>
                                <td>{payment.startDay} ~ {payment.endDay || '-'}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="3" style={{ textAlign: 'center' }}>납부 내역이 없습니다.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* --- Unpaid Fees --- */}
                <div className="management-fee-inquiry-results-unpaid-section">
                  <div className="management-fee-inquiry-results-section-header">
                    <h2 className="management-fee-inquiry-results-section-title">관리비 미납(또는 납부 예정) 내역</h2>
                    <div className="management-fee-inquiry-results-date-reference">{new Date().toLocaleDateString('ko-KR', { year: 'numeric', month: 'long', day: 'numeric' })} 기준</div>
                  </div>
                  <div className="management-fee-inquiry-results-unpaid-table">
                    <table>
                      <thead>
                        <tr>
                          <th>구분</th>
                          <th>최종 납부일</th>
                          <th>최종 납부금액</th>
                          <th>관리 기간</th>
                        </tr>
                      </thead>
                      <tbody>
                        {feeData?.unpaidFees && feeData.unpaidFees.length > 0 ? (
                          feeData.unpaidFees.map((unpaidFee, index) => {
                            return (
                              <tr key={index}>
                                <td>미납</td>
                                <td>{unpaidFee.receiptDay || unpaidFee.startDay || '-'}</td>
                                <td>{unpaidFee.receiptPrice || unpaidFee.managementPrice || '-'}</td>
                                <td>{unpaidFee.startDay} ~ {unpaidFee.endDay || '-'}</td>
                              </tr>
                            );
                          })
                        ) : (
                          <tr>
                            <td colSpan="4" style={{ textAlign: 'center' }}>미납 내역이 없습니다.</td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                  <div className="management-fee-inquiry-results-payment-status">
                    <p>
                      {feeData?.unpaidFees && feeData.unpaidFees.length > 0
                        ? '미납 금액이 있습니다. 관리사무실로 문의하세요.'
                        : '납부하실 금액이 없습니다.'
                      }
                    </p>
                  </div>
                </div>

                {/* --- Account Info --- */}
                <div className="management-fee-inquiry-results-account-info">
                  <div className="management-fee-inquiry-results-account-content">
                    <div className="management-fee-inquiry-results-account-icon">!</div>
                    <div className="management-fee-inquiry-results-account-text">
                      <p>관리비 입금 계좌번호 : {feeData?.accountBank || '농협'} {feeData?.accountNumber || '243100-51-021581'}</p>
                      <p>예금주 : {feeData?.accountHolder || '(주)강화파라다이스'}</p>
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default ManagementFeeInquiryResultsPC;
